import React from 'react';
import Footer from '../components/Footer';
import GamePage from '../components/GamePage';

import BalloonsOdyssey_MainScreen from '../images/balloonsodyssey/images-01.png';

function BalloonsOdyssey() {
  return (
    <>
      <GamePage
        name="Balloons Odyssey"
        description="Balloons Odyssey is a casual puzzle game. Your goal is to help Willy and his pet
        Birdy collecting balloons so they can keep their trip around world."
        images={[BalloonsOdyssey_MainScreen]}
        conclusion="Mostly developed using C# and Unity Engine this is a personal project to be released in 2022."
      />
      <Footer />
    </>
  );
}

export default BalloonsOdyssey;
